import React, { FC } from "react";
import { EvergisTileLayer } from "@evergis/react";
import { useWaitFor } from "@evergis/react-fetching/es/WaitFor";

import { useSharedProjectBaseMap } from "../../../hooks/sharing/useSharedProject";

export const Basemap: FC = () => {
  const isAuth = useWaitFor();
  const baseMap = useSharedProjectBaseMap();

  return !isAuth && !!baseMap && <EvergisTileLayer name={baseMap} zIndex={0} />;
};
